import { getUserDetails } from "./authUtils";
import { BUNDLE_BASE } from "./bundleBase";

const hostMapping = {
  "app.crm4b2c.com": "fieldsales.crm4b2c.com",
  "app-clone.crm4b2c.com": "fieldsales.crm4b2c.com",
  "app.lsq-staging.com": "fieldsales.lsq-staging.com",
  "app.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-us11.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-ca12.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-ir31.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-in21.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "app-in22.leadsquared.com": "fieldsales-in22.leadsquared.com",
  "run.crm4b2c.com": "fieldsales.crm4b2c.com",
  "run.lsq-staging.com": "fieldsales.lsq-staging.com",
  "in21.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "us11.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "ir31.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "ca12.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "run.leadsquared.com": "fieldsales-in21.leadsquared.com",
  "in22.leadsquared.com": "fieldsales-in22.leadsquared.com",
};

const orgCode = getUserDetails()?.OrgCode;
const marvinHostMapping = {
  "run.crm4b2c.com": `https://service.crm4b2c.com/v1/Marvin.svc/r1`,
  "app.crm4b2c.com": `https://service.crm4b2c.com/v1/Marvin.svc/r1`,
  "app-clone.crm4b2c.com": `https://service.crm4b2c.com/v1/Marvin.svc/r1`,

  "app.lsq-staging.com": `https://service.lsq-staging.com/v1/Marvin.svc/r1`,
  "run.lsq-staging.com": `https://service.lsq-staging.com/v1/Marvin.svc/r1`,
  "us11.lsq-staging.com": `https://service-us11.lsq-staging.com/v1/Marvin.svc/r11`,
  "app-us.lsq-staging.com": `https://service-us11.lsq-staging.com/v1/Marvin.svc/r11`,
  "in21.mxradon.lsq-staging.com": `https://marvin-service-in21.mxradon.lsq-staging.com/v1/Marvin.svc/r1`,
  "app-in21.mxradon.lsq-staging.com": `https://marvin-service-in21.mxradon.lsq-staging.com/v1/Marvin.svc/r1`,

  "ca12.leadsquared.com": `https://marvin-service-ca12.leadsquared.com/v1/Marvin.svc/r12`,
  "app-ca12.leadsquared.com": `https://marvin-service-ca12.leadsquared.com/v1/Marvin.svc/r12`,
  "ir31.leadsquared.com": `https://marvin-service-ir31.leadsquared.com/v1/Marvin.svc/r31`,
  "app-ir31.leadsquared.com": `https://marvin-service-ir31.leadsquared.com/v1/Marvin.svc/r31`,
  "in21.leadsquared.com": `https://marvin-service-in21.leadsquared.com/v1/Marvin.svc/r21`,
  "app-in21.leadsquared.com": `https://marvin-service-in21.leadsquared.com/v1/Marvin.svc/r21`,
  "run.leadsquared.com": `https://marvin-service.leadsquared.com/v1/Marvin.svc/r1`,
  "app.leadsquared.com": `https://marvin-service.leadsquared.com/v1/Marvin.svc/r1`,
  "us11.leadsquared.com": `https://marvin-service-us11.leadsquared.com/v1/Marvin.svc/r11`,
  "app-us11.leadsquared.com": `https://marvin-service-us11.leadsquared.com/v1/Marvin.svc/r11`,
  "in22.leadsquared.com": `https://marvin-service-in22.leadsquared.com/v1/Marvin.svc/r22`,
  "app-in22.leadsquared.com": `https://marvin-service-in22.leadsquared.com/v1/Marvin.svc/r22`,
  "nextgen-mum.leadsquared.com": `https://marvin-service-in21.leadsquared.com/v1/Marvin.svc/r21`,
  "nextgen-sgp.leadsquared.com": `https://marvin-service-in21.leadsquared.com/v1/Marvin.svc/r21`,
  "nextgen-us.leadsquared.com/": `https://marvin-service-us11.leadsquared.com/v1/Marvin.svc/r11`,
};

/**
 * The NextGen shell publishes its resolved environment config on the window it shares with this
 * microfrontend, under the key its own helpers read (`___env_var___`). IS_CUSTOM_DOMAIN is added
 * to that config by one script -- the shell's custom-domain deploy step -- so its presence is an
 * exact signal, not a heuristic on the hostname, and it is the same flag the shell's own rest
 * client gates its encryption on.
 */
const PLATFORM_ENV_KEY = "___env_var___";
const ORGCODE_PLACEHOLDER = "[[ORGCODE]]";

const platformEnvConfig = (key) =>
  typeof window === "undefined" ? undefined : window[PLATFORM_ENV_KEY]?.[key];

export const isCustomDomain = () => Boolean(platformEnvConfig("IS_CUSTOM_DOMAIN"));

/**
 * Empty in every deployment so far, which leaves the crypto library to resolve
 * `${window.location.origin}/api/gw` itself. Read anyway, and read from the shell's config rather
 * than our own, so that if NextGen ever points the handshake somewhere else we follow it instead
 * of opening a second session against a different gateway from inside the same page.
 */
export const gatewayBaseUrlOverride = () => platformEnvConfig("GATEWAY_BASE_URL") || "";

const getMarvinHost = () => {
  const currentHost = window.location.host;

  /**
   * Custom domain: the shell's env config already says which Marvin region this tenant talks to,
   * as a path on the serving origin -- appgateway matches /api/v1/Marvin.svc/** and strips /api
   * before forwarding. Reading its value rather than repeating the region map below keeps the two
   * in step: a region added on their side needs no change here. If the key is ever absent we fall
   * through to the map and the call stays cross-origin and unsealed, which is today's behaviour.
   */
  const shellMarvinPath = platformEnvConfig("API_URL")?.MARVIN;
  if (isCustomDomain() && shellMarvinPath) {
    return `${window.location.origin}${shellMarvinPath.replace(ORGCODE_PLACEHOLDER, orgCode)}`;
  }

const marvinBaseUrl = marvinHostMapping[currentHost]
  || (currentHost.includes("localhost") && marvinHostMapping["app.crm4b2c.com"])
  || marvinHostMapping["in21.leadsquared.com"];
  return marvinBaseUrl + "/" + orgCode;
};
export const marvinHost = getMarvinHost();

const getHostMapping = (host) => {
  if (host.includes("staging")) {
    return hostMapping["run.lsq-staging.com"];
  } else if (host.includes("leadsquared.com")) {
    return hostMapping["run.leadsquared.com"];
  }
  return hostMapping["run.crm4b2c.com"];
};

const envHostMapping = {
  local: "",
  test: "https://casa-lead-360.fieldsales.crm4b2c.com",
  staging: "https://casa-lead-360.fieldsales.lsq-staging.com",
  prod_in21: "https://casa-lead-360-in21.leadsquared.com",
  prod_in22: "https://casa-lead-360-in22.leadsquared.com",
};

const getCSSHost = () => {
  const currentHost = window.location.host;

  if (currentHost.includes("localhost")) {
    return envHostMapping.local;
  }
  if (currentHost.includes("staging.com")) {
    return envHostMapping.staging;
  }
  if (currentHost.includes("in22.leadsquared.com")) {
    return envHostMapping.prod_in22;
  }
  if (currentHost.includes("leadsquared.com")) {
    return envHostMapping.prod_in21;
  }
  return envHostMapping.test;
};
export const cssHost = BUNDLE_BASE || getCSSHost();

export const host =
  hostMapping?.[window.location.host] || getHostMapping(window.location.host);

/**
 * Custom domain: the shell serves this app from the tenant's own domain, and appgateway fronts
 * the APIs on that same origin -- it matches /api/fs/** and rewrites the path to /api/** before
 * forwarding to the FieldSales gateway, so `/fs` is inserted after /api rather than prefixed onto
 * the whole path. That route is shared with dashboard, territory and console.
 *
 * Same-origin is not cosmetic: the payload-crypto client resolves its gateway as
 * `${window.location.origin}/api/gw`, so only a same-origin request can be sealed. Everywhere
 * else the host map above still wins and the call stays cross-origin and unsealed, exactly as
 * today.
 */
export const casaServiceBaseUrl = isCustomDomain()
  ? `${window.location.origin}/api/fs/casa-service/v1`
  : `https://${host}/api/casa-service/v1`;
